exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attached-file-options{display:flex;align-items:center}.attached-file-options .image-input{opacity:0;position:absolute;width:25px}.chat-message-image{max-height:200px;max-width:150px;margin-right:10px}", ""]);

// exports
